












import { Component, Prop } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import { QueryReferralRecord, RevokePatient } from "@/api/pdReferral";
@Component({})
export default class PdPushList extends AbpBase {
  tableTotalSize: number = 0;
  loading: boolean = false;
  data: any[] = [];
  columns = [
    {
      title: "患者姓名",
      width: 100,
      key: "patientName"
    },
    {
      title: "身份证号",
      width: 200,
      key: "cid"
    },
    {
      title: "推送时间",
      width: 170,
      key: "referralTime",
      render: (h: any, p: any) => {
        return h(
          "span",
          {},
          this.fmtDate(new Date(p.row.referralTime), "yyyy-MM-dd hh:mm")
        );
      }
    },
    {
      title: "推送人",
      width: 100,
      key: "referralUserName"
    },
    {
      title: "目标社区",
      width: 200,
      ellipsis: true,
      tooltip: true,
      key: "sourceCommunityName"
    },
    {
      title: "推送状态",
      width: 120,
      key: "referralStatusName",
      render: (h: any, p: any) => {
        let props: any = {};
        if (p.row.referralStatusName == "待接收") {
          props.style = { color: "red" };
        }
        return h("span", props, p.row.referralStatusName);
      }
    },
    {
      title: "推送原因",
      ellipsis: true,
      tooltip: true,
      key: "referralReason",
      minWidth: 120,
    },
    {
      title: "操作",
      key: "",
      width: 100,
      render: (h: any, p: any) => {
        if (p.row.referralStatusName == "待接收") {
          return h(
            "Button",
            {
              props: { type: "primary", size: "small" },
              style: { marginRight: "10px" },
              on: {
                click: () => {
                  this.handleRevoke(p.row);
                }
              }
            },
            "撤回"
          );
        }
      }
    }
  ];

  //查询条件
  queryCondition: any = {
    skipCount: 1,
    maxResultCount: 10,
    queryString: "",
    referralUserId: ""
  };

  pageChange(val: any) {
    this.queryCondition.SkipCount = val;
    this.getData();
  }

  async getData() {
    this.loading = true;
    let res = await QueryReferralRecord(this.queryCondition);
    this.data = res.items;
    this.tableTotalSize = res.totalCount;
    this.$emit("refresh-push-count", this.tableTotalSize);
    this.loading = false;
  }

  handleRevoke(row: any) {
    this.$Modal.confirm({
      title: "提示",
      content: "确定要撤回吗？",
      onOk: async () => {
        await RevokePatient(row);
        this.getData();
      }
    });
  }

  created() {
    if (this.$store.state.session.user) {
      this.queryCondition.referralUserId = this.$store.state.session.user.id;
      this.getData();
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdReferral/pdPush/index.vue